import { useQuery } from '@tanstack/react-query';
import {
  fetchCampaignCount,
  fetchWalletBalance,
} from '@/features/dashboard/api/dashboardApi';
import { queryKeys } from '@/shared/lib/query/queryKeys';

export function useWalletBalanceQuery(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.wallet.balance(),
    queryFn: fetchWalletBalance,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: options?.enabled ?? true,
  });
}

export function useCampaignCountQuery() {
  return useQuery({
    queryKey: queryKeys.dashboard.campaignCount(),
    queryFn: fetchCampaignCount,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
